export default "__VITE_ASSET__a0e7ea88__"